// =============================================================================
// Project Management module — portfolio form (create/edit via the standard ModelFormPage)
// =============================================================================

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Page } from '/imports/ui/Page';
import { Checkbox } from '/imports/ui/Checkbox';
import { ImageInput } from '/imports/ui/ImageInput';
import { ModelFormPage } from '/imports/ui/ModelFormPage';
import { NotPermittedPage } from '/imports/ui/NotPermittedPage';
import { useUser, useFindOne } from '/imports/hooks';
import { Accounts } from '/imports/api/accounts';
import { strings } from '/imports/strings';
import { ProjectManagementPortfolio, projectManagementPortfolioModelClass, projectManagementIsAdmin } from '/imports/api/projectManagement';

const PortfolioPageStyled = styled(Page)`
`;

/** Create/edit one portfolio (name + note). */
export const ProjectManagementPortfolioPage = () => {
  const { _id } = useParams<any>();
  const user = useUser();
  const account = useFindOne(() => Accounts.find({ orgId: user?.orgId, userId: user?._id }), [user?._id]);
  const defaultUpdate: Partial<ProjectManagementPortfolio> = { _id, active: true };
  const [update, setUpdate] = useState<Partial<ProjectManagementPortfolio>>(defaultUpdate);
  if (!projectManagementIsAdmin(user, account)) return <NotPermittedPage />;  // portfolios are org-wide grouping — admin-only
  return <ModelFormPage
    modelClass={projectManagementPortfolioModelClass}
    styled={PortfolioPageStyled}
    defaultUpdate={defaultUpdate}
    update={update}
    setUpdate={setUpdate}
    formSpec={[
      [{ field: 'active', input: { type: Checkbox } }],
      [{ field: 'name', label: strings.Name(), asterisk: true }],
      [{ field: 'logo', label: strings.Logo(), input: { type: ImageInput }, optional: true }],
      [{ field: 'note', label: strings.Note(), optional: true }],
    ]}
  />;
};
